import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-bioinformatics",
  templateUrl: "./bioinformatics.component.html",
  styleUrls: ["./bioinformatics.component.scss"],
})
export class BioinformaticsComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    window.scrollTo(0, 0);
  }
}
